/* ═══════════════════════════════════════════════════════════════
   DepartmentService — firm departments lookup (MEPT, BIM, etc).

   Same drag-orderable shape as project_types / billing_types.  Drives:
     - team_members.department_id (one per person)
     - Forecast grid grouping
     - Team page department column
   ═══════════════════════════════════════════════════════════════ */

import type { Department } from '../../shared/entities';
import * as cache from './cloudCache';

const TABLE = 'departments';

export const DepartmentService = {
  list: async (): Promise<Department[]> => {
    const rows = await cache.list<Department>(TABLE);
    return rows.sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0));
  },

  get: async (id: string): Promise<Department | null> => {
    const all = await DepartmentService.list();
    return all.find((d) => d.id === id) || null;
  },

  save: async (dept: Department): Promise<Department> => cache.save(TABLE, dept),

  delete: async (id: string): Promise<void> => cache.remove(TABLE, id),
};
